import React, { ReactElement } from 'react';

import Node from 'craft/components/Node';
import Placeholder from 'craft/components/Placeholder';
import { CustomNodeData, Resolver, ToolboxComponentSections } from 'craft/types';
import { hasDescendants } from 'craft/utils';

export const VIEW_DEFAULT_STYLES = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  flexGrow: 1,
  padding: 8,
};

interface Props {
  children?: ReactElement | ReactElement[];
  placeholder?: ReactElement;
  custom?: CustomNodeData;
}

export const View: Resolver = ({ children, placeholder }: Props) => {
  const hasChildren = hasDescendants(children);
  const placeholderComponent = placeholder || <Placeholder />;

  return <Node data-cy="node-view">{hasChildren ? children : placeholderComponent}</Node>;
};

View.craft = {
  displayName: 'Layout',
  name: 'View',
  isCanvas: true,
};

View.toolbox = {
  schema: {
    [ToolboxComponentSections.Size]: {
      hasOverflow: true,
    },
  },
};
